export * from './getIndicator';